//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class CookiePolicy extends Component {
	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		const culture = this.props.culture;

		switch (culture) {
			case 'at':
				return (
					<div className="content-page__content">
						<h1>Cookie-Politik</h1>
						<h2>INFORMATIONEN ÜBER UNSERE VERWENDUNG VON COOKIES</h2>
						<p>Unsere Website verwendet ein Cookie, das das Funktionieren unserer Website ermöglicht. Dieses Cookie ist ein "funktionales" oder "unbedingt notwendiges" Cookie.</p>
                    <p>Diese Richtlinie kann von uns jederzeit geändert werden, indem wir die geänderte Richtlinie auf dieser Website veröffentlichen. Bitte überprüfen Sie diesen Abschnitt der Website regelmäßig auf etwaige Änderungen.</p>
                    <p>Wenn Sie auf der Website weitersurfen, erklären Sie sich mit der Verwendung des unbedingt erforderlichen Cookies einverstanden.</p>
                    <h2>WAS SIND COOKIES?</h2>
                    <p>Ein Cookie ist eine kleine Datei mit Buchstaben und Zahlen, die wir auf Ihrem Endgerät (z. B. Ihrem Computer, Tablet oder Smartphone) speichern. Sofern Sie Ihren Browser nicht so eingestellt haben, dass er Cookies ablehnt, wird unser System Cookies setzen, sobald Sie unsere Website besuchen.</p>
                <p>Weitere Informationen über Cookies, einschließlich Informationen darüber, wie Sie sehen können, welche Cookies gesetzt wurden und wie Sie diese verwalten und löschen können, finden Sie unter <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>WIE WIR COOKIES VERWENDEN</h2>
                <p>Zum Zeitpunkt der Erstellung dieses Dokuments wird auf dieser Website nur ein funktionales Cookie verwendet.  Er ermöglicht es der Website, auf Klicks zu reagieren und zu einer ausgewählten Seite zu wechseln.</p>
                <p>Weitere Informationen über die Cookies, die wir auf dieser Website verwenden, finden Sie in der nachstehenden Tabelle:</p>

						<table>
							<thead>
								<tr>
									<th>Cookie-ID</th>
									<th>Typ</th>
									<th>Grund für die Verwendung</th>
									<th>Verfallszeit</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>KulturPräferenz</td>
									<td>Funktions-Cookie</td>
									<td>Speicherung der Präferenzen der Nutzer auf der Seite für die Länder-/Sprachauswahl auf der Website, damit diese bei künftigen Besuchen umgangen werden kann.</td>
									<td>2 Wochen</td>
								</tr>
								
							</tbody>
						</table>
						<p>Bitte beachten Sie, dass Links von Dritten auf unserer Website ebenfalls Cookies verwenden können; Sie können diese Cookies erhalten, wenn Sie auf den Link zur Website des Dritten klicken. Wir haben keine Kontrolle über die Sammlung oder Verwendung von Informationen durch diese Dritten, und sie unterliegen nicht dieser Cookie-Richtlinie.</p>
                <h2>WAS SIE TUN KÖNNEN, WENN SIE NICHT MÖCHTEN, DASS COOKIES GESETZT WERDEN</h2>
                <p>Sie können Cookies blockieren, indem Sie die Einstellung Ihres Browsers aktivieren, mit der Sie das Setzen aller oder einiger Cookies ablehnen können. In der "Hilfe" Ihres Browsers erfahren Sie, wie Sie die Cookie-Einstellungen verwalten können.</p>
                <p>Bitte beachten Sie, dass Teile unserer Website möglicherweise nicht richtig funktionieren, wenn Sie Cookies deaktivieren.</p>
                <p>Datum der Erstellung März 2024.</p>
					</div>
				);
   case 'cz':
				return (
					<div className="content-page__content">
				<h1>Zásady používání souborů cookie</h1>
                    <h2>INFORMACE O NAŠEM POUŽÍVÁNÍ SOUBORŮ COOKIES</h2>
                    <p>Naše stránky používají soubory cookie, které umožňují fungování našich webových stránek. Tento soubor cookie je „funkční“ nebo „nezbytně nutný“ soubor cookie.</p>
                    <p>Tyto zásady mohou být kdykoli změněny zveřejněním upravených zásad na této stránce. Pravidelně prosím kontrolujte tuto část webu, zda nedošlo k nějakým změnám.</p>
                    <p>Pokračováním v procházení stránek souhlasíte s naším používáním nezbytně nutných souborů cookie.</p>
                    <h2>CO JSOU COOKIES?</h2>
                    <p>Cookie je malý soubor písmen a čísel, který ukládáme na vašem koncovém zařízení (jako je váš počítač, tablet nebo chytrý telefon). Pokud jste neupravili nastavení svého prohlížeče tak, aby odmítal soubory cookie, náš systém bude soubory cookie vydávat, jakmile navštívíte naše stránky.</p>
                    <p>Další informace o souborech cookie, včetně toho, jak zjistit, jaké soubory cookie byly nastaveny a jak je spravovat a mazat, naleznete na adrese <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>JAK POUŽÍVÁME COOKIES</h2>
                    <p>V době psaní tohoto článku je funkční jediný soubor cookie používaný na tomto webu. Umožňuje webu reagovat na kliknutí a přesunout se na vybranou stránku.</p>
                    <p>Více informací o cookies, které používáme na tomto webu, naleznete v tabulce níže:</p>
                    <p>
                        <table>
							<thead>
								<tr>
									<th>ID souboru cookie</th>
									<th>Typ</th>
									<th>Důvod použití</th>
									<th>Doba platnosti</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>kulturaPreference</td>
									<td>Funkční cookie</td>
									<td>Chcete-li uložit preference uživatelů na stránce výběru země/jazyka na webu, aby to bylo možné při budoucích návštěvách obejít.</td>
									<td>2 týdny</td>
								</tr>
							</tbody>
						</table>
                </p>
                  <p>Vezměte prosím na vědomí, že jakékoli odkazy třetích stran na našich stránkách mohou také používat soubory cookie; tyto soubory cookie můžete obdržet kliknutím na odkaz na stránky třetí strany. Nemáme kontrolu nad shromažďováním nebo používáním informací těmito třetími stranami a nevztahují se na ně tato pravidla týkající se souborů cookie.</p>
                    <h2>CO DĚLAT, KDYŽ NECHCETE NASTAVOVAT COOKIES</h2>
                    <p>Soubory cookie můžete zablokovat aktivací nastavení ve vašem prohlížeči, které vám umožňuje odmítnout nastavení všech nebo některých souborů cookie. Chcete-li zjistit, jak spravovat nastavení souborů cookie, přejděte ve svém prohlížeči do části „Nápověda“.</p>
                    <p>Uvědomte si prosím, že pokud zakážete soubory cookie, části našich stránek nemusí fungovat správně.</p>
                    <p>Datum přípravy březen 2024.</p>	
                        </div>
				);        
	       case 'de':
				return (
					<div className="content-page__content">
						<h1>Cookie-Politik</h1>
						<h2>INFORMATIONEN ÜBER UNSERE VERWENDUNG VON COOKIES</h2>
						<p>Unsere Website verwendet ein Cookie, das das Funktionieren unserer Website ermöglicht. Dieses Cookie ist ein "funktionales" oder "unbedingt notwendiges" Cookie.</p>
                    <p>Diese Richtlinie kann von uns jederzeit geändert werden, indem wir die geänderte Richtlinie auf dieser Website veröffentlichen. Bitte überprüfen Sie diesen Abschnitt der Website regelmäßig auf etwaige Änderungen.</p>
                    <p>Wenn Sie auf der Website weitersurfen, erklären Sie sich mit der Verwendung des unbedingt erforderlichen Cookies einverstanden.</p>
                    <h2>WAS SIND COOKIES?</h2>
                    <p>Ein Cookie ist eine kleine Datei mit Buchstaben und Zahlen, die wir auf Ihrem Endgerät (z. B. Ihrem Computer, Tablet oder Smartphone) speichern. Sofern Sie Ihren Browser nicht so eingestellt haben, dass er Cookies ablehnt, wird unser System Cookies setzen, sobald Sie unsere Website besuchen.</p>
                <p>Weitere Informationen über Cookies, einschließlich Informationen darüber, wie Sie sehen können, welche Cookies gesetzt wurden und wie Sie diese verwalten und löschen können, finden Sie unter <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>WIE WIR COOKIES VERWENDEN</h2>
                <p>Zum Zeitpunkt der Erstellung dieses Dokuments wird auf dieser Website nur ein funktionales Cookie verwendet.  Er ermöglicht es der Website, auf Klicks zu reagieren und zu einer ausgewählten Seite zu wechseln.</p>
                <p>Weitere Informationen über die Cookies, die wir auf dieser Website verwenden, finden Sie in der nachstehenden Tabelle:</p>
						<table>
							<thead>
								<tr>
									<th>Cookie-ID</th>
									<th>Typ</th>
									<th>Grund für die Verwendung</th>
									<th>Verfallszeit</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>KulturPräferenz</td>
									<td>Funktions-Cookie</td>
									<td>Speicherung der Präferenzen der Nutzer auf der Seite für die Länder-/Sprachauswahl auf der Website, damit diese bei künftigen Besuchen umgangen werden kann.</td>
									<td>2 Wochen</td>
								</tr>
								
							</tbody>
						</table>
						<p>Bitte beachten Sie, dass Links von Dritten auf unserer Website ebenfalls Cookies verwenden können; Sie können diese Cookies erhalten, wenn Sie auf den Link zur Website des Dritten klicken. Wir haben keine Kontrolle über die Sammlung oder Verwendung von Informationen durch diese Dritten, und sie unterliegen nicht dieser Cookie-Richtlinie.</p>
                <h2>WAS SIE TUN KÖNNEN, WENN SIE NICHT MÖCHTEN, DASS COOKIES GESETZT WERDEN</h2>
                <p>Sie können Cookies blockieren, indem Sie die Einstellung Ihres Browsers aktivieren, mit der Sie das Setzen aller oder einiger Cookies ablehnen können. In der "Hilfe" Ihres Browsers erfahren Sie, wie Sie die Cookie-Einstellungen verwalten können.</p>
                <p>Bitte beachten Sie, dass Teile unserer Website möglicherweise nicht richtig funktionieren, wenn Sie Cookies deaktivieren.</p>
                <p>Datum der Erstellung März 2024.</p>
					</div>
				);
			case 'dk':
				return (
					<div className="content-page__content">
						<h1>Cookie-politik</h1>
						<h2>INFORMATION OM VORES BRUG AF COOKIES</h2>
						
                   <p>Vores websted bruger en cookie, der gør det muligt for vores websted at fungere. Denne cookie er en "funktionel" eller "strengt nødvendig" cookie.</p>
                    <p>Denne politik kan til enhver tid ændres af os ved at offentliggøre den ændrede politik på dette websted. Tjek venligst dette afsnit af webstedet regelmæssigt for eventuelle ændringer.</p>
                    <p>Ved at fortsætte med at browse på webstedet accepterer du vores brug af den strengt nødvendige cookie.</p>
                    <h2>HVAD ER COOKIES?</h2>
                    <p>En cookie er en lille fil med bogstaver og tal, som vi gemmer på dit terminaludstyr (f.eks. din computer, tablet eller smartphone). Medmindre du har justeret dine browserindstillinger, så de afviser cookies, vil vores system udstede cookies, så snart du besøger vores websted.</p>
                    <p>Du kan finde ud af mere om cookies, herunder hvordan du ser, hvilke cookies der er blevet sat, og hvordan du administrerer og sletter dem, ved at besøge <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a></p>
                    <h2>SÅDAN BRUGER VI COOKIES</h2>
                <p>I skrivende stund er den eneste cookie, der bruges på denne hjemmeside, funktionel.  Den gør det muligt for hjemmesiden at reagere på klik og flytte til en valgt side. </p>
                <p>Flere oplysninger om de cookies, vi bruger på denne hjemmeside, kan findes i tabellen nedenfor:</p>
						<table>
							<thead>
								<tr>
									<th>Cookies-ID</th>
									<th>Type</th>
									<th>Årsag til brug</th>
									<th>Udløbstidspunkt</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Funktionalitets-cookie</td>
									<td> At gemme brugernes præferencer på siden til valg af land/sprog på webstedet, så dette kan omgås ved deres fremtidige besøg.</td>
									<td>2 uger</td>
								</tr>
							</tbody>
						</table>
                    <p>Bemærk, at alle tredjepartslinks på vores websted også kan bruge cookies; du kan modtage disse cookies ved at klikke på linket til tredjepartswebstedet. Vi kontrollerer ikke disse tredjeparters indsamling eller brug af oplysninger, og de er ikke omfattet af denne cookiepolitik.</p>
                    <h2>HVAD DU SKAL GØRE, HVIS DU IKKE ØNSKER, AT DER SÆTTES COOKIES</h2>
                    <p>Du kan blokere cookies ved at aktivere den indstilling i din browser, der giver dig mulighed for at afvise indstillingen af alle eller nogle cookies. Du kan gå til afsnittet "Hjælp" i din browser for at lære, hvordan du administrerer cookie-indstillinger.</p>
                    <p>Vær opmærksom på, at dele af vores websted muligvis ikke fungerer korrekt, hvis du deaktiverer cookies.</p>
                    <p>Dato for udarbejdelse Mar 2024.</p>
					</div>
				);
                case 'lu':
				return (
					<div className="content-page__content">
						<h1>Cookie-Politik</h1>
						<h2>INFORMATIONEN ÜBER UNSERE VERWENDUNG VON COOKIES</h2>
						<p>Unsere Website verwendet ein Cookie, das das Funktionieren unserer Website ermöglicht. Dieses Cookie ist ein "funktionales" oder "unbedingt notwendiges" Cookie.</p>
                    <p>Diese Richtlinie kann von uns jederzeit geändert werden, indem wir die geänderte Richtlinie auf dieser Website veröffentlichen. Bitte überprüfen Sie diesen Abschnitt der Website regelmäßig auf etwaige Änderungen.</p>
                    <p>Wenn Sie auf der Website weitersurfen, erklären Sie sich mit der Verwendung des unbedingt erforderlichen Cookies einverstanden.</p>
                    <h2>WAS SIND COOKIES?</h2>
                    <p>Ein Cookie ist eine kleine Datei mit Buchstaben und Zahlen, die wir auf Ihrem Endgerät (z. B. Ihrem Computer, Tablet oder Smartphone) speichern. Sofern Sie Ihren Browser nicht so eingestellt haben, dass er Cookies ablehnt, wird unser System Cookies setzen, sobald Sie unsere Website besuchen.</p>
                <p>Weitere Informationen über Cookies, einschließlich Informationen darüber, wie Sie sehen können, welche Cookies gesetzt wurden und wie Sie diese verwalten und löschen können, finden Sie unter <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>WIE WIR COOKIES VERWENDEN</h2>
                <p>Zum Zeitpunkt der Erstellung dieses Dokuments wird auf dieser Website nur ein funktionales Cookie verwendet.  Er ermöglicht es der Website, auf Klicks zu reagieren und zu einer ausgewählten Seite zu wechseln.</p>
                <p>Weitere Informationen über die Cookies, die wir auf dieser Website verwenden, finden Sie in der nachstehenden Tabelle:</p>
						<table>
							<thead>
								<tr>
									<th>Cookie-ID</th>
									<th>Typ</th>
									<th>Grund für die Verwendung</th>
									<th>Verfallszeit</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>KulturPräferenz</td>
									<td>Funktions-Cookie</td>
									<td>Speicherung der Präferenzen der Nutzer auf der Seite für die Länder-/Sprachauswahl auf der Website, damit diese bei künftigen Besuchen umgangen werden kann.</td>
									<td>2 Wochen</td>
								</tr>
								
							</tbody>
						</table>
						<p>Bitte beachten Sie, dass Links von Dritten auf unserer Website ebenfalls Cookies verwenden können; Sie können diese Cookies erhalten, wenn Sie auf den Link zur Website des Dritten klicken. Wir haben keine Kontrolle über die Sammlung oder Verwendung von Informationen durch diese Dritten, und sie unterliegen nicht dieser Cookie-Richtlinie.</p>
                <h2>WAS SIE TUN KÖNNEN, WENN SIE NICHT MÖCHTEN, DASS COOKIES GESETZT WERDEN</h2>
                <p>Sie können Cookies blockieren, indem Sie die Einstellung Ihres Browsers aktivieren, mit der Sie das Setzen aller oder einiger Cookies ablehnen können. In der "Hilfe" Ihres Browsers erfahren Sie, wie Sie die Cookie-Einstellungen verwalten können.</p>
                <p>Bitte beachten Sie, dass Teile unserer Website möglicherweise nicht richtig funktionieren, wenn Sie Cookies deaktivieren.</p>
                <p>Datum der Erstellung März 2024.</p>
					</div>
				);
                case 'lu-fr':
				return (
					<div className="content-page__content">
						<h1>Politique en matière de cookies</h1>
						<h2>INFORMATIONS SUR NOTRE UTILISATION DES COOKIES</h2>
					<p>Notre site utilise un cookie qui permet à notre site web de fonctionner. Il s'agit d'un cookie "fonctionnel" ou "strictement nécessaire". </p>
                    <p>Nous pouvons modifier cette politique à tout moment en publiant la politique modifiée sur ce site. Veuillez consulter régulièrement cette section du site pour prendre connaissance des éventuelles modifications.</p>
                    <p>En continuant à naviguer sur le site, vous acceptez que nous utilisions le cookie strictement nécessaire.</p>
                    <h2>QU'EST-CE QU'UN COOKIE ?</h2>
                    <p>Un cookie est un petit fichier de lettres et de chiffres que nous stockons sur votre équipement terminal (tel que votre ordinateur, votre tablette ou votre smartphone). Sauf si vous avez paramétré votre navigateur pour qu'il refuse les cookies, notre système émet des cookies dès que vous visitez notre site.</p>
                    <p>Vous pouvez en savoir plus sur les cookies, notamment sur la manière de voir quels cookies ont été installés et sur la manière de les gérer et de les supprimer, en visitant le site <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>COMMENT NOUS UTILISONS LES COOKIES</h2>
                    <p>Au moment de la rédaction du présent document, le seul cookie utilisé sur ce site web est le cookie fonctionnel.  Il permet au site web de répondre aux clics et de passer à la page sélectionnée.</p>
                    <p>Vous trouverez plus d'informations sur les cookies que nous utilisons sur ce site web dans le tableau ci-dessous :</p>
                    <p>
                        <table>
							<thead>
								<tr>
									<th>ID du cookie</th>
									<th>Type de cookie</th>
									<th>Raison de l'utilisation</th>
									<th>Durée d'expiration</th>
								</tr>
							</thead>
                            <tbody>
								<tr>
									<td>culturePreference</td>
									<td>Cookie de fonctionnalité</td>
									<td>Pour enregistrer la préférence de l'utilisateur sur la page de sélection du pays/de la langue sur le site web afin qu'il puisse l'ignorer lors de ses prochaines visites.</td>
									<td>2 semaines</td>
								</tr>
							</tbody>
						</table>
                    </p>
                    <p>Veuillez noter que les liens de tiers sur notre site peuvent également utiliser des cookies ; vous pouvez recevoir ces cookies en cliquant sur le lien vers le site du tiers. Nous ne contrôlons pas la collecte ou l'utilisation d'informations par ces tiers et ils ne sont pas soumis à la présente politique en matière de cookies.</p>
                    <h2>QUE FAIRE SI VOUS NE VOULEZ PAS QUE DES COOKIES SOIENT INSTALLÉS ?</h2>
                    <p>Vous pouvez bloquer les cookies en activant le paramètre de votre navigateur qui vous permet de refuser l'installation de tous les cookies ou de certains d'entre eux. Vous pouvez consulter la section "Aide" de votre navigateur pour savoir comment gérer les paramètres des cookies.</p>
                    <p>Sachez que certaines parties de notre site peuvent ne pas fonctionner correctement si vous désactivez les cookies.</p>
                    <p>Date de préparation : mars 2024.</p>
            </div>
				);
			case 'ie':
				return (
					<div className="content-page__content">
						<h1>Cookie policy</h1>
						<h2>INFORMATION ABOUT OUR USE OF COOKIES</h2>
						<p>Our Site uses a cookie that allow our website to function. This cookie is a “functional” or “strictly necessary” cookie.</p>
                    <p>This policy may be amended by us at any time by posting the amended policy on this Site. Please check this section of the Site regularly for any changes.</p>
                    <p>By continuing to browse the Site, you are agreeing to our use of the strictly necessary cookie.</p>
                    <h2>WHAT ARE COOKIES?</h2>
                    <p>A cookie is a small file of letters and numbers that we store on your terminal equipment (such as your computer, tablet or smartphone). Unless you have adjusted your browser settings so that it will refuse cookies, our system will issue cookies as soon as you visit our site.</p>
                    <p>You can find out more about cookies, including how to see what cookies have been set and how to manage and delete them, by visiting <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>HOW WE USE COOKIES</h2>
                    <p>At the time of writing, the only cookie used on this website is functional.  It allows the website to respond to clicks and move to a selected page.</p>
                    <p>More information about the cookies that we use on this website can be found in the table below:</p>
                    <p>
                        	<table>
							<thead>
								<tr>
									<th>Cookie ID</th>
									<th>Type</th>
									<th>Reason for use</th>
									<th>Expiry time</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Functionality cookie</td>
									<td>To store the users’ preference on the country/language selection page on the website so this can be bypassed on their future visits.</td>
									<td>2 weeks</td>
								</tr>
							</tbody>
						</table>
                </p>
                    <p>Please note that any third-party links on our Site may also use cookies; you may receive these cookies by clicking on the link to the third-party site. We do not control the collection or use of information by these third parties, and they are not subject to this cookie policy.</p>
                    <h2>WHAT TO DO IF YOU DON’T WANT COOKIES TO BE SET</h2>
                    <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. You can go to the “Help” section of your browser to learn how to manage cookie settings.</p>
                    <p>Please be aware that parts of our Site may not function correctly if you disable cookies.</p>
                    <p>Date of Preparation Mar 2024.</p>                    
                    </div>
				);
			case 'it':
				return (
					<div className="content-page__content">
						<h1>Politica sui cookie</h1>
						<h2>INFORMAZIONI SUL NOSTRO UTILIZZO DEI COOKIE</h2>
					<p>Il nostro sito utilizza un cookie che consente al nostro sito di funzionare. Questo cookie è un cookie "funzionale" o "strettamente necessario".</p>
                    <p>Questa politica può essere modificata da noi in qualsiasi momento pubblicando la politica modificata su questo Sito. Si prega di controllare regolarmente questa sezione del Sito per eventuali modifiche.</p>
                    <p>Continuando a navigare sul Sito, l'utente accetta l'utilizzo del cookie strettamente necessario.</p>
                    <h2>COSA SONO I COOKIE?</h2>
                    <p>Un cookie è un piccolo file di lettere e numeri che viene memorizzato sul terminale dell'utente (come il computer, il tablet o lo smartphone). A meno che non abbiate regolato le impostazioni del vostro browser in modo da rifiutare i cookie, il nostro sistema li emette non appena visitate il nostro sito.</p>
                    <p>Per saperne di più sui cookie, tra cui come vedere quali sono stati impostati e come gestirli ed eliminarli, visitate il sito <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>COME UTILIZZIAMO I COOKIE</h2>
                    <p>Al momento della stesura del presente documento, l'unico cookie utilizzato su questo sito è quello funzionale.  Consente al sito web di rispondere ai clic e di passare a una pagina selezionata.</p>
                    <p>Per ulteriori informazioni sui cookie utilizzati in questo sito web, consultare la tabella seguente:</p>
                    <p>
                    <table>
							<thead>
								<tr>
									<th>ID del cookie</th>
									<th>Tipo</th>
									<th>Motivo dell’utilizzo</th>
									<th>Tempo di scadenza</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturaPreferenza</td>
									<td>Cookie di funzionalità</td>
									<td>Per memorizzare la preferenza dell'utente nella pagina di selezione del paese/lingua del sito web, in modo da poterla aggirare nelle visite future.</td>
									<td>2 settimane</td>
								</tr>
							</tbody>
						</table></p>
						<p>Si prega di notare che anche i link di terze parti presenti sul nostro Sito possono utilizzare i cookie; l'utente può ricevere questi cookie facendo clic sul link al sito di terze parti. Non controlliamo la raccolta o l'utilizzo di informazioni da parte di queste terze parti, che non sono soggette alla presente politica sui cookie.</p>
                        <h2>COSA FARE SE NON SI DESIDERA CHE VENGANO IMPOSTATI I COOKIE</h2>
                        <p>È possibile bloccare i cookie attivando l'impostazione del browser che consente di rifiutare l'impostazione di tutti o di alcuni cookie. Per sapere come gestire le impostazioni dei cookie, potete consultare la sezione "Aiuto" del vostro browser.</p>
                    <p>Si prega di notare che alcune parti del nostro Sito potrebbero non funzionare correttamente se si disabilitano i cookie.</p>
                    <p>Data di preparazione Mar 2024.</p>                    
                    </div>
				);
			case 'no':
				return (
					<div className="content-page__content">
						<h1>Retningslinjer for informasjonskapsler</h1>
						<h2>INFORMASJON OM VÅR BRUK AV INFORMASJONSKAPSLER</h2>
                    <p>Nettstedet vårt bruker en informasjonskapsel som gjør det mulig for nettstedet vårt å fungere. Denne informasjonskapselen er en "funksjonell" eller "strengt nødvendig" informasjonskapsel.</p>
                    <p>Vi kan når som helst endre disse retningslinjene ved å legge ut de endrede retningslinjene på dette nettstedet. Vennligst sjekk denne delen av nettstedet regelmessig for eventuelle endringer.</p>
                    <p>Ved å fortsette å surfe på nettstedet godtar du vår bruk av den strengt nødvendige informasjonskapselen.</p>
                    <h2>HVA ER INFORMASJONSKAPSLER?</h2>
                    <p>En informasjonskapsel er en liten fil med bokstaver og tall som vi lagrer på terminalutstyret ditt (f.eks. datamaskin, nettbrett eller smarttelefon). Med mindre du har justert innstillingene i nettleseren din slik at den avviser informasjonskapsler, vil systemet vårt sende ut informasjonskapsler så snart du besøker nettstedet vårt.</p>
                    <p>Du kan finne ut mer om informasjonskapsler, inkludert hvordan du kan se hvilke informasjonskapsler som er satt og hvordan du kan administrere og slette dem, ved å gå til <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>HVORDAN VI BRUKER INFORMASJONSKAPSLER</h2>
                    <p>I skrivende stund er den eneste informasjonskapselen som brukes på dette nettstedet, en funksjonell informasjonskapsel.  Den gjør det mulig for nettstedet å reagere på klikk og flytte til en valgt side.</p>
                    <p>Mer informasjon om informasjonskapslene vi bruker på dette nettstedet, finner du i tabellen nedenfor:</p>
                    <p>
                        <table>
							<thead>
								<tr>
									<th>Navn på informasjonskapsel</th>
									<th>Type informasjonskapsel</th>
									<th>Årsak til bruk</th>
									<th>Utløpstid</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Informasjonskapsel for funksjonalitet</td>
									<td>For å lagre brukernes preferanser på siden for valg av land/språk på nettstedet, slik at dette kan forbigås ved fremtidige besøk.</td>
									<td>2 uker</td>
								</tr>
                            </tbody>
						</table>
                </p>
                <p>Vær oppmerksom på at tredjepartslenker på nettstedet vårt også kan bruke informasjonskapsler; du kan motta disse informasjonskapslene ved å klikke på lenken til tredjepartssiden. Vi kontrollerer ikke innsamlingen eller bruken av informasjon fra disse tredjepartene, og de er ikke underlagt disse retningslinjene for informasjonskapsler.</p>
                <h2>HVA DU SKAL GJØRE HVIS DU IKKE ØNSKER AT DET SETTES INFORMASJONSKAPSLER</h2>
                <p>Du kan blokkere informasjonskapsler ved å aktivere innstillingen i nettleseren din som lar deg nekte å motta alle eller noen informasjonskapsler. Du kan gå til "Hjelp"-delen i nettleseren din for å finne ut hvordan du administrerer innstillingene for informasjonskapsler.</p>
                <p>Vær oppmerksom på at deler av nettstedet vårt kanskje ikke vil fungere korrekt hvis du deaktiverer informasjonskapsler.</p>
                <p>Dato for utarbeidelse Mars 2024.</p>
                </div>
				);
			case 'pt':
				return (
					<div className="content-page__content">
						<h1>Política de cookies</h1>
						<h2>INFORMAÇÕES SOBRE A NOSSA UTILIZAÇÃO DE COOKIES</h2>
                    <p>O nosso sítio utiliza um cookie que permite o funcionamento do nosso sítio. Este cookie é um cookie "funcional" ou "estritamente necessário".</p>
                <p>Esta política pode ser alterada por nós em qualquer altura, publicando a política alterada neste Sítio. Consulte regularmente esta secção do Sítio para se inteirar de quaisquer alterações.</p>
                <p>Ao continuar a navegar no Sítio, está a concordar com a nossa utilização do cookie estritamente necessário.</p>
                <h2>O QUE SÃO COOKIES?</h2>
                <p>Um cookie é um pequeno ficheiro de letras e números que armazenamos no seu equipamento terminal (como o seu computador, tablet ou smartphone). A menos que tenha ajustado as definições do seu navegador de modo a recusar cookies, o nosso sistema emitirá cookies assim que visitar o nosso sítio.</p>
                <p>Pode saber mais sobre cookies, incluindo como ver que cookies foram definidos e como geri-los e eliminá-los, visitando <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                <h2>COMO UTILIZAMOS OS COOKIES</h2>
                <p>No momento da redação deste documento, o único cookie utilizado neste sítio Web é o funcional.  Permite que o sítio Web responda a cliques e passe para uma página selecionada.</p>
                <p>Mais informações sobre os cookies que utilizamos neste sítio Web podem ser consultadas na tabela abaixo:</p>
                    <p>
						<table>
							<thead>
								<tr>
									<th>ID do cookie</th>
									<th>Tipo de cookie</th>
									<th>Motivo de utilização</th>
									<th>Tempo de expiração</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturaPreferência</td>
									<td>Cookie de funcionalidade</td>
									<td>Para armazenar a preferência dos utilizadores na página de seleção de país/língua no sítio Web, de modo a que esta possa ser contornada nas suas futuras visitas.</td>
									<td>2 semanas</td>
								</tr>
							</tbody>
						</table>
						</p>
                    <p>Tenha em atenção que quaisquer ligações de terceiros no nosso Sítio também podem utilizar cookies; pode receber estes cookies clicando na ligação para o sítio de terceiros. Não controlamos a recolha ou utilização de informações por estes terceiros e estes não estão sujeitos a esta política de cookies.</p>
                    <h2>O QUE FAZER SE NÃO QUISER QUE OS COOKIES SEJAM DEFINIDOS</h2>
                    <p>Pode bloquear os cookies activando a definição no seu navegador que lhe permite recusar a definição de todos ou alguns cookies. Pode ir à secção "Ajuda" do seu browser para saber como gerir as definições de cookies.</p>
                    <p>Tenha em atenção que partes do nosso Sítio podem não funcionar corretamente se desativar os cookies.</p>
                    <p>Data de preparação Mar 2024.</p>
					</div>
				);
			case 'se':
				return (
					<div className="content-page__content">
						<h1>Policy för cookies</h1>
						<h2>INFORMATION OM VÅR ANVÄNDNING AV COOKIES</h2>
				<p>Vår webbplats använder en cookie som gör att vår webbplats kan fungera. Denna cookie är en "funktionell" eller "strikt nödvändig" cookie.</p>
                    <p>Denna policy kan ändras av oss när som helst genom att publicera den ändrade policyn på denna webbplats. Vänligen kontrollera detta avsnitt av webbplatsen regelbundet för eventuella ändringar.</p>
                    <p>Genom att fortsätta att surfa på webbplatsen godkänner du vår användning av den absolut nödvändiga kakan.</p>
                    <h2>VAD ÄR COOKIES?</h2>
                    <p>En cookie är en liten fil med bokstäver och siffror som vi lagrar på din terminalutrustning (t.ex. din dator, surfplatta eller smartphone). Om du inte har ställt in din webbläsare så att den inte tillåter cookies kommer vårt system att lagra cookies så snart du besöker vår webbplats.</p>
                    <p>Du kan läsa mer om cookies, inklusive hur du ser vilka cookies som har ställts in och hur du hanterar och tar bort dem, genom att besöka <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>HUR VI ANVÄNDER COOKIES</h2>
                <p>I skrivande stund är den enda cookie som används på denna webbplats funktionell.  Den gör det möjligt för webbplatsen att reagera på klick och flytta till en vald sida.</p>
                    <p>Mer information om de cookies som vi använder på denna webbplats finns i tabellen nedan:</p>
                    <p>
						<table>
							<thead>
								<tr>
									<th>ID för cookie</th>
									<th>Typ</th>
									<th>Anledning till användning</th>
									<th>Utgångstid</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>kulturPreferens</td>
									<td>Cookie för funktionalitet</td>
									<td>För att lagra användarnas preferenser på sidan för val av land/språk på webbplatsen så att detta kan förbigås vid framtida besök</td>
									<td>2 veckor</td>
								</tr>
							</tbody>
						</table>
                    </p>
                <p>Observera att tredjepartslänkar på vår webbplats också kan använda cookies; du kan ta emot dessa cookies genom att klicka på länken till tredjepartssajten. Vi kontrollerar inte dessa tredje parters insamling eller användning av information, och de omfattas inte av denna cookiepolicy.</p>
                    <h2>VAD DU SKA GÖRA OM DU INTE VILL ATT COOKIES SKA STÄLLAS IN</h2>
                    <p>Du kan blockera cookies genom att aktivera den inställning i din webbläsare som gör att du kan neka alla eller vissa cookies. Du kan gå till avsnittet "Hjälp" i din webbläsare för att lära dig hur du hanterar cookieinställningar.</p>
                    <p>Tänk på att delar av vår Webbplats kanske inte fungerar korrekt om du inaktiverar cookies.</p>
                    <p>Datum för färdigställande Mars 2024.</p>
					</div> 
				);
            case 'lv':
				return (
					<div className="content-page__content">
						<h1>Sīkfailu politika</h1>
					<h2>INFORMĀCIJA PAR MŪSU SĪKFAILU IZMANTOŠANU</h2>
                    <p>Mūsu vietnē tiek izmantoti sīkfaili, kas nodrošina mūsu vietnes darbību. Šis sīkfails ir "funkcionāls" vai "absolūti nepieciešams" sīkfails.</p>
                    <p>Mēs varam jebkurā laikā grozīt šo politiku, publicējot grozīto politiku šajā vietnē. Lūdzu, regulāri pārbaudiet šo vietnes sadaļu, lai uzzinātu par jebkādām izmaiņām.</p>
                    <p>Turpinot pārlūkot Vietni, jūs piekrītat, ka mēs izmantojam obligāti nepieciešamo sīkfailu.</p>
                    <h2>KAS IR SĪKFAILI?</h2>
                    <p>Sīkdatne ir neliela burtu un ciparu datne, ko mēs saglabājam jūsu gala iekārtā (piemēram, datorā, planšetdatorā vai viedtālrunī). Ja vien neesat pielāgojis pārlūkprogrammas iestatījumus tā, lai tā atteiktu sīkdatnes, mūsu sistēma izdod sīkdatnes, tiklīdz jūs apmeklējat mūsu vietni.</p>
                    <p>Plašāku informāciju par sīkdatnēm, tostarp par to, kā redzēt, kādas sīkdatnes ir iestatītas, kā tās pārvaldīt un dzēst, varat uzzināt, apmeklējot vietni <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>KĀ MĒS IZMANTOJAM SĪKDATNES</h2>
                <p>Rakstīšanas brīdī vienīgā sīkdatne, kas tiek izmantota šajā vietnē, ir funkcionālā.  Tā ļauj tīmekļa vietnei reaģēt uz klikšķiem un pāriet uz izvēlēto lapu.</p>
                    <p>Sīkāka informācija par sīkfailiem, ko mēs izmantojam šajā tīmekļa vietnē, ir sniegta turpmāk tabulā:</p>
                    <p>
                    <table>
							<thead>
								<tr>
									<th>Sīkdatnes ID</th>
									<th>Tips</th>
									<th>Izmantošanas iemesls</th>
									<th>Derīguma termiņš</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Funkcionalitātes sīkfails</td>
									<td>Lai saglabātu lietotāja izvēli valsts/valodas izvēles lapā tīmekļa vietnē, lai to varētu apiet nākamajos apmeklējumos.</td>
									<td>2 nedēļas</td>
								</tr>
								</tbody>
						</table>
						</p>
                    <p>Lūdzu, ņemiet vērā, ka jebkuras trešo personu saites mūsu vietnē var izmantot arī sīkfailus; jūs varat saņemt šos sīkfailus, noklikšķinot uz saites uz trešās personas vietni. Mēs nekontrolējam šo trešo personu informācijas vākšanu vai izmantošanu, un uz tām neattiecas šī sīkfailu politika.</p>
                    <h2>KO DARĪT, JA NEVĒLATIES, LAI TIKTU IESTATĪTAS SĪKDATNES	</h2>
                    <p>Jūs varat bloķēt sīkfailus, aktivizējot iestatījumu savā pārlūkprogrammā, kas ļauj atteikties no visu vai dažu sīkfailu iestatīšanas. Lai uzzinātu, kā pārvaldīt sīkfailu iestatījumus, varat doties uz pārlūkprogrammas sadaļu "Palīdzība".	</p>
                    <p>Lūdzu, ņemiet vērā, ka mūsu vietnes daļas var nedarboties pareizi, ja atspējojat sīkdatnes.</p>
                    <p>Sagatavošanas datums 2024. marts.</p>
					</div>
				);
            case 'ee':
				return (
					<div className="content-page__content">
						<h1>Küpsiste poliitika</h1>
                    <h2>TEAVE MEIE KÜPSISTE KASUTAMISE KOHTA</h2>
                    <p>Meie veebileht kasutab küpsiseid, mis võimaldavad meie veebilehe toimimist. See küpsis on "funktsionaalne" või "rangelt vajalik" küpsis.</p>
                    <p>Me võime seda poliitikat igal ajal muuta, avaldades muudetud poliitika sellel saidil. Palun kontrollige seda osa saidil regulaarselt muudatuste osas.</p>
                    <p>Veebisaidi sirvimist jätkates nõustute sellega, et me kasutame rangelt vajalikku küpsist.</p>
                    <h2>MIS ON KÜPSISED?</h2>
                    <p>Küpsis on väike tähtedest ja numbritest koosnev fail, mille me salvestame teie lõppseadmesse (näiteks arvutisse, tahvelarvutisse või nutitelefoni). Kui te ei ole oma brauseri seadeid nii seadistanud, et see keeldub küpsiste kasutamisest, väljastab meie süsteem küpsised kohe, kui külastate meie veebilehte.</p>
                    <p>Rohkem teavet küpsiste kohta, sealhulgas selle kohta, kuidas näha, milliseid küpsiseid on seatud ning kuidas neid hallata ja kustutada, leiate veebilehelt <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>KUIDAS ME KASUTAME KÜPSISEID</h2>
                    <p>Selle veebisaidi koostamise ajal on ainus küpsis, mida sellel veebisaidil kasutatakse, funktsionaalne.  See võimaldab veebisaidil reageerida klõpsamistele ja liikuda valitud lehele.</p>
                    <p>Lisateavet küpsiste kohta, mida me sellel veebisaidil kasutame, leiate alljärgnevast tabelist:</p>
                    <p>
                        <table>
							<thead>
								<tr>
				<th>Küpsiste ID</th>
                <th>Tüüp</th>
                <th>Kasutamise põhjus</th>
                <th>Kehtivusaeg</th>
								</tr>
							</thead>
						<tbody>
                    <tr>
                    <td>culturePreference</td>
                    <td>Funktsionaalsuse küpsis</td>
                    <td>Kasutajate eelistuste salvestamiseks veebisaidi riigi/keele valimise lehel, et seda saaks tulevastel külastustel vältida.</td>
                    <td>2 nädalat</td>
                </tr>
                </tbody>
						</table>
				</p>
                <p>Pange tähele, et kõik meie saidil olevad kolmandate osapoolte lingid võivad samuti kasutada küpsiseid; te võite neid küpsiseid saada, kui klõpsate lingile kolmanda osapoole saidile. Me ei kontrolli nende kolmandate osapoolte poolt kogutavat või kasutatavat teavet ning nende suhtes ei kehti käesolev küpsiste poliitika.</p>
                <h2>MIDA TEHA, KUI TE EI SOOVI KÜPSISTE KASUTAMIST</h2>
                <p>Te saate küpsised blokeerida, aktiveerides oma brauseris seadistuse, mis võimaldab teil keelduda kõigi või mõnede küpsiste seadistamisest. Küpsiste seadete haldamise kohta saate teavet oma brauseri "Abi" jaotisest.</p>
                <p>Palun arvestage, et meie veebilehe osad ei pruugi korrektselt toimida, kui te keelate küpsised.</p>
                <p>Ettevalmistamise kuupäev märts 2024.</p>
                </div>
				);
case 'hr':
				return (
					<div className="content-page__content">
						<h1>Politika kolačića</h1>
                    <h2>INFORMACIJE O NAŠOJ UPOTREBI KOLAČIĆA</h2>
                    <p>Naša stranica koristi kolačić koji omogućuje funkcioniranje naše stranice. Ovaj kolačić je "funkcionalni" ili "strogo nužan" kolačić.</p>
                    <p>Ovu politiku možemo izmijeniti u bilo kojem trenutku objavljivanjem izmijenjene politike na ovoj stranici. Redovito provjeravajte ovaj odjeljak Stranice za eventualne promjene.</p>
                    <p>Nastavkom pregledavanja web-mjesta pristajete na našu upotrebu nužno potrebnog kolačića.</p>
                    <h2>ŠTO SU KOLAČIĆI?</h2>
                    <p>Kolačić je mala datoteka slova i brojeva koju pohranjujemo na vašu terminalnu opremu (kao što je vaše računalo, tablet ili pametni telefon). Osim ako niste prilagodili postavke svog preglednika tako da odbija kolačiće, naš sustav će izdati kolačiće čim posjetite našu stranicu.</p>
                    <p>Možete saznati više o kolačićima, uključujući kako vidjeti koji su kolačići postavljeni te kako njima upravljati i brisati ih, posjetite <a href="http://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>KAKO KORISTIMO KOLAČIĆE</h2>
                <p>U vrijeme pisanja, jedini kolačić koji se koristi na ovoj web stranici je funkcionalan. Omogućuje web stranici da odgovori na klikove i prijeđe na odabranu stranicu.</p>
                    <p>Više informacija o kolačićima koje koristimo na ovoj web stranici možete pronaći u tablici ispod:</p>
                <p>
                <table>
				<thead>
				<tr>
                    <th>ID kolačića</th>
                    <th>Tip</th>
                    <th>Razlog korištenja</th>
                    <th>Vrijeme isteka</th>
				</tr>
					</thead>
					<tbody>
                        <tr>
                        <td>culturePreference</td>
                        <td>Kolačić funkcionalnosti</td>
                        <td>Za pohranjivanje korisničkih preferencija na stranici za odabir zemlje/jezika na web stranici kako bi se to moglo zaobići pri njihovim budućim posjetima.</td>
                        <td>2 tjedna</td>
                        </tr>
                </tbody>
				</table>
                </p>
                    <p>Imajte na umu da sve veze trećih strana na našem web-mjestu također mogu koristiti kolačiće; ove kolačiće možete primiti klikom na poveznicu na stranicu treće strane. Ne kontroliramo prikupljanje ili korištenje informacija od strane ovih trećih strana i one ne podliježu ovoj politici kolačića.</p>
                    <h2>ŠTO UČINITI AKO NE ŽELITE DA SE KOLAČIĆI POSTAVLJAJU</h2>
                    <p>Kolačiće možete blokirati aktiviranjem postavke u pregledniku koja vam omogućuje da odbijete postavku svih ili nekih kolačića. Možete otići u odjeljak "Pomoć" u svom pregledniku kako biste saznali kako upravljati postavkama kolačića.</p>
                    <p>Imajte na umu da dijelovi naše stranice možda neće ispravno funkcionirati ako onemogućite kolačiće.</p>
                    <p>Datum pripreme ožujak 2024.</p>
                </div>
				);
case 'pl':
				return (
					<div className="content-page__content">
					<h1>Polityka Cookie</h1>
                    <h2>INFORMACJA O STOSOWANIU PRZEZ NAS PLIKÓW COOKIES</h2>
                    <p>Nasza witryna korzysta z plików cookie, które umożliwiają jej działanie. Ten plik cookie jest „funkcjonalnym” lub „bezwzględnie niezbędnym” plikiem cookie.</p>
                    <p>Niniejsza polityka może zostać przez nas zmieniona w dowolnym momencie poprzez zamieszczenie zmienionej polityki w tej Witrynie. Prosimy regularnie sprawdzać tę sekcję Witryny pod kątem jakichkolwiek zmian.</p>
                    <p>Kontynuując przeglądanie Strony, wyrażasz zgodę na używanie przez nas absolutnie niezbędnego pliku cookie.</p>
                    <h2>CZYM SĄ PLIKI COOKIES?</h2>
                    <p>Plik cookie to mały plik składający się z liter i cyfr, który przechowujemy na Twoim urządzeniu końcowym (takim jak komputer, tablet lub smartfon). O ile nie dostosowałeś ustawień swojej przeglądarki tak, aby odrzucała pliki cookie, nasz system wygeneruje pliki cookie natychmiast po odwiedzeniu naszej witryny.</p>
                    <p>Więcej informacji na temat plików cookie, w tym o tym, jakie pliki cookie zostały ustawione oraz jak nimi zarządzać i je usuwać, można znaleźć na stronie <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>JAK KORZYSTAMY Z PLIKÓW COOKIES</h2>
                <p>W chwili pisania tego tekstu jedyny plik cookie używany na tej stronie jest funkcjonalny. Dzięki temu witryna reaguje na kliknięcia i przenosi się na wybraną stronę.
Więcej informacji na temat plików cookies, których używamy na tej stronie znajdziesz w poniższej tabeli:</p>
                    <p>
            <table>
				<thead>
				<tr>
				<th>Identyfikator pliku cookie</th>
                <th>Typ</th>
                <th>Powód użycia</th>
                <th>Czas wygaśnięcia</th>
				</tr>
				</thead>
				<tbody>
                <tr>
                <td>Preferencje kulturowe</td>
                <td>Funkcjonalny plik cookie</td>
                <td>Aby zapisać preferencje użytkowników na stronie wyboru kraju/języka w witrynie, aby można było je ominąć podczas przyszłych wizyt.</td>
                <td>2 tygodnie</td>
                </tr>
                </tbody>
						</table>
                </p>
<p>Należy pamiętać, że wszelkie linki stron trzecich w naszej Witrynie mogą również wykorzystywać pliki cookie; możesz otrzymać te pliki cookie, klikając łącze do witryny strony trzeciej. Nie kontrolujemy gromadzenia ani wykorzystywania informacji przez te strony trzecie i nie podlegają one niniejszej polityce dotyczącej plików cookie.</p>
                    <h2>CO ZROBIĆ, JEŚLI NIE CHCESZ ZAPISYWAĆ PLIKÓW COOKIES</h2>
                <p>Możesz zablokować pliki cookie, aktywując ustawienie w swojej przeglądarce, które pozwala na odmowę ustawienia wszystkich lub niektórych plików cookie. Możesz przejść do sekcji „Pomoc” swojej przeglądarki, aby dowiedzieć się, jak zarządzać ustawieniami plików cookies.</p>
                    <p>Należy pamiętać, że części naszej Strony mogą nie działać poprawnie, jeśli wyłączysz pliki cookie.</p>
                    <p>Data przygotowania marzec 2024.</p>
                </div>
				);
	
case 'uk':
				return (
					<div className="content-page__content">
						<h1>Cookie policy</h1>
						<h2>INFORMATION ABOUT OUR USE OF COOKIES</h2>
						<p>Our Site uses a cookie that allow our website to function. This cookie is a “functional” or “strictly necessary” cookie.</p>
                    <p>This policy may be amended by us at any time by posting the amended policy on this Site. Please check this section of the Site regularly for any changes.</p>
                    <p>By continuing to browse the Site, you are agreeing to our use of the strictly necessary cookie.</p>
                    <h2>WHAT ARE COOKIES?</h2>
                    <p>A cookie is a small file of letters and numbers that we store on your terminal equipment (such as your computer, tablet or smartphone). Unless you have adjusted your browser settings so that it will refuse cookies, our system will issue cookies as soon as you visit our site.</p>
                    <p>You can find out more about cookies, including how to see what cookies have been set and how to manage and delete them, by visiting <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>HOW WE USE COOKIES</h2>
                    <p>At the time of writing, the only cookie used on this website is functional.  It allows the website to respond to clicks and move to a selected page.</p>
                    <p>More information about the cookies that we use on this website can be found in the table below:</p>
                    <p>
                        	<table>
							<thead>
								<tr>
									<th>Cookie ID</th>
									<th>Type</th>
									<th>Reason for use</th>
									<th>Expiry time</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Functionality cookie</td>
									<td>To store the users’ preference on the country/language selection page on the website so this can be bypassed on their future visits.</td>
									<td>2 weeks</td>
								</tr>
							</tbody>
						</table>
                </p>
                    <p>Please note that any third-party links on our Site may also use cookies; you may receive these cookies by clicking on the link to the third-party site. We do not control the collection or use of information by these third parties, and they are not subject to this cookie policy.</p>
                    <h2>WHAT TO DO IF YOU DON’T WANT COOKIES TO BE SET</h2>
                    <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. You can go to the “Help” section of your browser to learn how to manage cookie settings.</p>
                    <p>Please be aware that parts of our Site may not function correctly if you disable cookies.</p>
                    <p>Date of Preparation March 2024.</p>                    
                    </div>
				);
			default: //global
				return (
					<div className="content-page__content">
											<h1>Cookie policy</h1>
						<h2>INFORMATION ABOUT OUR USE OF COOKIES</h2>
						<p>Our Site uses a cookie that allow our website to function. This cookie is a “functional” or “strictly necessary” cookie.</p>
                    <p>This policy may be amended by us at any time by posting the amended policy on this Site. Please check this section of the Site regularly for any changes.</p>
                    <p>By continuing to browse the Site, you are agreeing to our use of the strictly necessary cookie.</p>
                    <h2>WHAT ARE COOKIES?</h2>
                    <p>A cookie is a small file of letters and numbers that we store on your terminal equipment (such as your computer, tablet or smartphone). Unless you have adjusted your browser settings so that it will refuse cookies, our system will issue cookies as soon as you visit our site.</p>
                    <p>You can find out more about cookies, including how to see what cookies have been set and how to manage and delete them, by visiting <a href="https://www.allaboutcookies.org/" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.</p>
                    <h2>HOW WE USE COOKIES</h2>
                    <p>At the time of writing, the only cookie used on this website is functional.  It allows the website to respond to clicks and move to a selected page.</p>
                    <p>More information about the cookies that we use on this website can be found in the table below:</p>
                    <p>
                        	<table>
							<thead>
								<tr>
									<th>Cookie ID</th>
									<th>Type</th>
									<th>Reason for use</th>
									<th>Expiry time</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>culturePreference</td>
									<td>Functionality cookie</td>
									<td>To store the users’ preference on the country/language selection page on the website so this can be bypassed on their future visits.</td>
									<td>2 weeks</td>
								</tr>
							</tbody>
						</table>
                </p>
                    <p>Please note that any third-party links on our Site may also use cookies; you may receive these cookies by clicking on the link to the third-party site. We do not control the collection or use of information by these third parties, and they are not subject to this cookie policy.</p>
                    <h2>WHAT TO DO IF YOU DON’T WANT COOKIES TO BE SET</h2>
                    <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. You can go to the “Help” section of your browser to learn how to manage cookie settings.</p>
                    <p>Please be aware that parts of our Site may not function correctly if you disable cookies.</p>
                    <p>Date of Preparation March 2024.</p>                    
					</div>
				);
		}
	}
}

export default CookiePolicy;



// WEBPACK FOOTER //
// ./src/content/legal/cookiePolicy.js